// src/pages/Documentation/utils/markdownLoader.ts
const FETCH_TIMEOUT = 5000; // 5 seconds timeout

export async function loadMarkdownContent(path) {
  const timeoutPromise = new Promise((_, reject) => {
    setTimeout(() => {
      reject(new Error('Request timeout'));
    }, FETCH_TIMEOUT);
  });

  try {
    // Race between fetch and timeout
    const response = await Promise.race([fetch(path), timeoutPromise]);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const markdown = await response.text();

    // Simple front matter parser
    const parseFrontMatter = (content) => {
      const frontMatterRegex = /^---\n([\s\S]*?)\n---\n([\s\S]*)$/;
      const match = content.match(frontMatterRegex);

      if (!match) {
        return {
          content: content,
          metadata: {},
        };
      }

      const [, frontMatter, markdownContent] = match;
      const metadata = {};

      // Parse YAML-style front matter
      frontMatter.split('\n').forEach((line) => {
        const [key, ...valueParts] = line.split(':');
        if (key && valueParts.length) {
          const value = valueParts.join(':').trim();
          metadata[key.trim()] = value;
        }
      });

      return {
        content: markdownContent.trim(),
        metadata,
      };
    };

    const { content, metadata } = parseFrontMatter(markdown);

    return {
      content,
      metadata,
    };
  } catch (error) {
    console.error('Error loading markdown:', error);
    throw error; // Re-throw to handle in component
  }
}
